import { RosterPerson } from 'app/api/roster';

export function formatPerson(person: RosterPerson): string {
    return `${person.givenName} ${person.surname}`;
}
